import { render, staticRenderFns } from "./Persona_editar.vue?vue&type=template&id=52654a9a&scoped=true"
import script from "./Persona_editar.vue?vue&type=script&lang=js"
export * from "./Persona_editar.vue?vue&type=script&lang=js"
import style0 from "./Persona_editar.vue?vue&type=style&index=0&id=52654a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52654a9a",
  null
  
)

export default component.exports